import { AxiosPromise } from 'axios';
import request from '../network';

export function overviewByCrmApi(shopId: any) {
  return request({
    url: '/member/royalcanin/admin/homePage/overviewByCrm',
    method: 'POST',
    data: { shopId },
  });
}

// 埋点
export function getUserClickApi(menuId: any, level: number, crowdId: any, labelId: any, parentId: any, router: any) {
  return request({
    url: '/system/home/click',
    method: 'get',
    params: { menuId, level, crowdId, labelId, parentId, router },
  });
}

// 首页
export function systemHomeApi() {
  return request({
    url: '/system/home/system',
    method: 'get',
    // params: { userName: username, type }
  });
}
export function systemHomeMainDataApi(data: any) {
  return request({
    url: '/cdpdata/data/overview/mainData',
    method: 'post',
    data,
    // params: { userName: username, type }
  });
}

// 首页
export function homePieApi() {
  return request({
    url: '/cdpdata/data/overview/homePie',
    method: 'post',
    // params: { userName: username, type }
  });
}
